import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ScNavbarComponent } from './components/sc-navbar/sc-navbar.component';
import { ScQuoteImageBannerComponent } from './components/sc-quote-image-banner/sc-quote-image-banner.component';
import { ActionButtonComponent } from './components/action-button/action-button.component';

@NgModule({
  declarations: [ScNavbarComponent, ScQuoteImageBannerComponent, ActionButtonComponent],
  exports: [ScNavbarComponent, ScQuoteImageBannerComponent, ActionButtonComponent],
  imports: [CommonModule],
})
export class UIModule {}
